import PropTypes from "prop-types";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect } from "react";

function AnimatedNumber({ value, prefix = "", decimals = 0, duration = 1, suffix }) {
  const motionValue = useMotionValue(value);

  const rounded = useTransform(motionValue, (latest) =>
    latest.toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    })
  );

  useEffect(() => {
    if (typeof value === "number" && !isNaN(value)) {
      const controls = animate(motionValue, value, {
        duration, // smooth duration instead of physics
        ease: "easeOut",
      });
      return controls.stop; // cleanup
    }
  }, [value, motionValue, duration]);

  return (
    <motion.span>
      {prefix}
      <motion.span style={{ display: "inline-block" }}>{rounded}</motion.span>
      {suffix}
    </motion.span>
  );
}

AnimatedNumber.propTypes = {
  value: PropTypes.number.isRequired,
  prefix: PropTypes.string,
  decimals: PropTypes.number,
  duration: PropTypes.number, // control animation speed
  suffix: PropTypes.string,
};

export default AnimatedNumber;
